import nodeService from "@/services/nodejs"

const fetchItineraries = (state, formDate) => {
  state.commit("SET_ISLOADING", true)

  nodeService.getOperations(formDate)
    .then(res => {
      var response = res.data
      state.commit("SET_CALENDAR_DATA", response)
      state.commit("SET_ISLOADING", false)
    })
    .catch((error) => { })
}

const blockDayProduct = (state, payload) => {
  state.commit("SET_ISLOADING", true)

  nodeService.postBlockDayProduct(payload)
    .then(res => {
      state.commit("SET_ISLOADING", false)
    })
    .catch((error) => { })
}

const unblockDayProduct = (state, payload) => {
  state.commit("SET_ISLOADING", true)

  nodeService.postUnblockDayProduct(payload)
    .then(res => {
      state.commit("SET_ISLOADING", false)
    })
    .catch((error) => { })
}

const fetchBookingByUUID = (state, UUID) => {
  state.commit("SET_ISLOADING", true)
  state.commit("RESET_BILL_ITEM_DETAILS")

  nodeService.getBookingByUUID(UUID)
    .then(res => {
      var response = res.data

      response.forEach(e => {
        e.payload = typeof e.payload == 'string' ? JSON.parse(e.payload) : e.payload
        // TODO: remove this ajust
        if(e.paymentMethod == undefined){
          e.paymentMethod = e.payload.payments[0].payment_method
        }
        if(e.payment_channel == undefined){
          e.payment_channel = e.payload.payments[0].payment_description
        }
        // END TODO

        updateStatus(state, e, true)
      })

      state.commit("SET_BOOKING_DETAILS", response)
      state.commit("SET_ISLOADING", false)
    })
    .catch((error) => {
      console.error('erro ao buscar reservas', UUID, error)
    })
}

function formatDaySummary(state, bookings){
  var daySummary = {
    'Online':{'Crédito':0,'Débito':0,'Pix':0,'Carteira':0,'Total':0},
    'Maquininha':{'Crédito':0,'Débito':0,'Pix':0,'Dinheiro':0,'Total':0},
    'Visitantes':{'Inteira':0,'Meia Entrada':0,'Cortesia':0,'Total':0},
    'Checkin':{'Confirmados':0,'Aguardando Checkin':0},
    'Não confirmadas':{'Não pagas':0,'Canceladas':0}
  }
  var daySummaryTypes = {'wallet':'Carteira','credito':'Crédito','debito':'Débito','pix':'Pix','dinheiro':'Dinheiro'}

  if (bookings.length > 0) {
    bookings.forEach((booking) => {
      let channel = booking['channel']
      let paymentChannel = booking['payment_channel']
      let finalValue = booking['finalValue']
      let itemPersonType = booking['itemPersonType']

      // checkedin amount
      switch (booking['status']) {
        case 'UNPAID':
          daySummary['Não confirmadas']['Não pagas'] += 1
          break;

        case 'PENDING':
          daySummary['Não confirmadas']['Não pagas'] += 1
          break;

        case 'DENIED':
          daySummary['Não confirmadas']['Não pagas'] += 1
          break;

        case 'CANCELLED':
          daySummary['Não confirmadas']['Canceladas'] += 1
          break;

        case 'APPROVED':

          if(booking['checkin']['hasCheckin']){
            daySummary['Checkin']['Confirmados'] += booking['people']['tableText']['count']
          }
          else {
            daySummary['Checkin']['Aguardando Checkin'] += booking['people']['tableText']['count']
            return
          }

          // people amount
          Object.keys(itemPersonType).forEach(personType => {
            let _lowerPersonType = personType.toLowerCase()

            //cortesia
            if(paymentChannel.indexOf('Cortesia') != -1){
              _lowerPersonType = "Cortesia"
            }else{
              if(_lowerPersonType == "meia" || _lowerPersonType == "meia entrada"){
                _lowerPersonType = "Meia Entrada"
              }
              if(_lowerPersonType == "inteira"){
                _lowerPersonType = "Inteira"
              }
              if(_lowerPersonType == "cortesia"){
                _lowerPersonType = "Cortesia"
              }
            }

            if(daySummary['Visitantes'][_lowerPersonType] == undefined){ daySummary['Visitantes'][_lowerPersonType] = 0 }

            daySummary['Visitantes'][_lowerPersonType] += itemPersonType[personType]['count']
            daySummary['Visitantes']['Total'] += itemPersonType[personType]['count']
          })

          //cortesia
          if(paymentChannel.indexOf('Cortesia') != -1){
            return
          }

          // money value

          switch (channel) {
            case 'WORDPRESS':
              channel = 'Online'
              break;

            case 'POSCONTROLE':
              channel = 'Maquininha'

              booking.payments.forEach((payment) => {
                let payment_pos_type = payment.data_origin.TEFType || payment.data_origin.Name

                switch (payment_pos_type) {
                    case '01':
                      paymentChannel = 'Débito'
                      break;
                    case '02':
                      paymentChannel = 'Crédito'
                      break;
                    case '06':
                      paymentChannel = 'Pix'
                      break;
                    case 'Dinheiro':
                      paymentChannel = 'Dinheiro'
                      break;
                    case 'Cortesia':
                      paymentChannel = 'Cortesia'
                      break;
                    default:
                        if(payment.payment_description.toUpperCase().indexOf('WALLET') == 0){
                          paymentMethod = 'Carteira'

                        }else{
                          console.error('TIPO DE PAGAMENTO DESCONHECIDO!')
                          paymentChannel = 'Dinheiro'
                        }
                  }


                  if(daySummary[channel] == undefined){ daySummary[channel] = {} }
                  if(daySummary[channel][paymentChannel] == undefined){ daySummary[channel][paymentChannel] = 0 }

                  daySummary[channel][paymentChannel] += Number(payment.payment_value)
                  daySummary[channel]['Total'] += Number(payment.payment_value)

                })
              break;

            default:
              channel = 'Online'
              break;
          }

          if(channel != 'Maquininha' && finalValue > 0 ){

            if(booking.payments[0].payment_description.toUpperCase().indexOf('WALLET') == 0){
              paymentChannel = 'Carteira'
            }

            if(daySummary[channel] == undefined){ daySummary[channel] = {} }
            if(daySummary[channel][paymentChannel] == undefined){ daySummary[channel][paymentChannel] = 0 }

            daySummary[channel][paymentChannel] += finalValue
            daySummary[channel]['Total'] += finalValue
          }
          break;

        default:
          break;
      }


    })

    Object.keys(daySummary).forEach((channel) => {
      let _sortedItems = []

      Object.keys(daySummary[channel]).forEach((method) => {
        _sortedItems.push({ title: method, value: daySummary[channel][method] })
      })

      daySummary[channel] = _sortedItems
    })
  }

  return daySummary
}

/**
 * set booking status
 * #227BA0 Azul
 * #22A06B Verde
 * #D93051 Vermelho
 * #A67C00 Amarelo
 * #5F6368 Cinza
 *
 * @param {*} state
 * @param {*} booking booking object
 * @param {*} hasPayloadData has or dont payload
 * @returns
 */
const updateStatus = (state, booking, hasPayloadData) => {

  //Colors
  let Azul = '#227BA0'
  let Verde = '#22A06B'
  let Vermelho = '#D93051'
  let Amarelo = '#A67C00'
  let Cinza = '#5F6368'

  // Payment methods
  let bookingPaidStatusArray = JSON.parse(JSON.stringify(state.rootState.operacao.bookingPaidStatusArray))

  let paymentMethodsAliases = JSON.parse(JSON.stringify(state.rootState.operacao.paymentMethodsAliases))

  let paymentMethodsAlias = []


  if(hasPayloadData){
    booking.agents = booking.payload.agents
    booking.checkins = booking.payload.checkins
    booking.channel = booking.payload.channel
  }

  console.log('booking.channel',booking.channel)


  if(booking.paymentMethod == ""){
    booking.paymentMethod = 'cortesia'
  }

  paymentMethodsAlias = paymentMethodsAliases[booking.paymentMethod.toUpperCase()]
  booking['paymentMethodOrigin'] = booking.paymentMethod

  if(booking.paymentMethod == 'pos'){
    if(booking.channel == undefined){
      booking.channel = 'POSCONTROLE'                   // REMOVER NO BACKEND
    }
    booking.paymentMethod = booking.payment_channel.split(' - ')[0]
    booking.paymentMethod = booking.paymentMethod.replace('ito', 'it')
    booking.paymentMethod = `pos_${booking.paymentMethod}`
    paymentMethodsAlias = paymentMethodsAliases[booking.paymentMethod.toUpperCase()]
    booking.payment_channel = `POS - ${paymentMethodsAlias != undefined ? paymentMethodsAlias.title : booking.paymentMethod}`
  }

  if(paymentMethodsAlias == undefined){
    booking.paymentMethod = 'UNKNOWN'
    paymentMethodsAlias = paymentMethodsAliases[booking.paymentMethod.toUpperCase()]
  }

  if(booking.payment_channel.indexOf('Stripe') >= 0){
    booking.paymentMethod = 'Stripe'
    booking.channel = 'RESERVALARAVEL'
  }

  if(booking.channel == undefined && booking.paymentMethod.toUpperCase() == 'PIX'){   // REMOVER NO BACKEND
    booking.channel = 'RESERVAEXPRESSA'               // REMOVER NO BACKEND
  }

  if(booking.channel == undefined){
    booking.channel = 'WORDPRESS'                       // REMOVER NO BACKEND
  }

  booking.paymentMethod = paymentMethodsAlias.slug
  booking.payment_channel = paymentMethodsAlias.title
  booking.finalValue = Number(booking.valor - booking.item_discount)


  // Status (Booking, Order, Payment)
  booking.statusText = 'Pendente'
  booking.paymentStatusText = 'Sem Pagamento'
  booking.orderStatusText = 'Pendente'
  booking.channelText = ''
  booking.statusColor = Vermelho

  // payment
  if (bookingPaidStatusArray.indexOf(booking.status.toUpperCase()) >= 0) {
    booking.statusText = 'Aguardando Check-in'
    booking.paymentStatusText = 'Pago'
    booking.orderStatusText = 'Concluído'
    booking.statusColor = Azul

    // checkins
    if((booking.checkin && booking.checkin.hasCheckin) || (booking.checkins && booking.checkins.length > 0)){
      booking.statusText = 'Realizada'
      booking.statusColor = Verde
    }

    // agents
    if(!booking.agents || booking.agents.length == 0){
      // booking.statusText += ' (sem condutor)'
      booking.statusColor = Azul
    }
  }

  if(booking.status.toUpperCase() == 'CANCELLED'){
    booking.statusText = 'Cancelada'
    booking.paymentStatusText = 'Cancelado'
    booking.orderStatusText = 'Cancelado'
    booking.statusColor = Vermelho
  }

  //channel
  switch (booking.channel) {
    case 'WORDPRESS':
      booking.channelText = 'Site Janoo'
      break;
    case 'RESERVAEXPRESSA':
      booking.channelText = 'Reserva Expressa'
      break;
    case 'RESERVALARAVEL':
      booking.channelText = 'Site'
      break;
    case 'POSCONTROLE':
      booking.channelText = 'Portaria'
      break;
    default:
      break;
  }

  return booking
}

const fetchBillItemsByUUID = (state, params) => {
  state.commit("SET_ISLOADING", true)
  state.commit("RESET_BILL_ITEM_DETAILS")

  nodeService.getBillItems(params)
    .then(res => {
      var response = res.data[0]
      response = updateStatus(state, response, false)
      state.commit("SET_BILL_ITEM_DETAILS", response)
      state.commit("SET_ISLOADING", false)
    })
    .catch((error) => {
      console.error('erro ao buscar reservas', error)
    })
}

const resetBookingDetails = (state) => {
  state.commit("RESET_BILL_ITEM_DETAILS")
}

export default {
  fetchItineraries,
  fetchBookingByUUID,
  fetchBillItemsByUUID,
  resetBookingDetails,
  updateStatus,
  blockDayProduct,
  unblockDayProduct,
  formatDaySummary,
}
